import React from 'react';
import MicroApp from '@/components/micro-app';
import './index.less';

function CtoB({ url, name }) {
  return (
    <div className="operationsWorkbench-wrapper">
      <MicroApp name={name} url={url} />
    </div>
  );
}

export default CtoB;
